// Libraries
import { v4 as uuidv4 } from 'uuid'

// Utilities
import isEmpty from './isEmpty'
import logger from './loggerUtil'
import SessionUtil from './sessionUtil'
import { KeyConstants } from '../constants'

class PreferenceUtil {
  static localStorageKey = 'preferencesUtil_'

  static get (key, defaultValue) {
    const value = SessionUtil.getCookie(this.localStorageKey + key)

    if (isEmpty(value)) {
      if (defaultValue === undefined) {
        throw new Error('No preference found using key: ' + key)
      }

      return defaultValue
    }

    return value
  }

  /**
   * Save the passed in preference value. Expiration only applies to browsers.
   */
  static set (key, value, expiration = 999999) {
    SessionUtil.setCookie(PreferenceUtil.localStorageKey + key, value, expiration)
  }

  static delete (key) {
    SessionUtil.deleteCookie(PreferenceUtil.localStorageKey + key)
  }

  /**
   * Gets the custom session ID used for analytics before an application, customer, or profile ID exists.
   */
  static getSessionId () {
    let sessionId = this.get(KeyConstants.sessionId, '')

    if (isEmpty(sessionId)) {
      sessionId = uuidv4()

      logger.debug(`Setting session ID to ${sessionId}`)

      PreferenceUtil.set(KeyConstants.sessionId, sessionId, 99000000) // Save for over 99 years
    }

    return sessionId
  }
}

export default PreferenceUtil
